import { CircularProgress } from "@mui/material";

interface Props {
  text?: string;
  color?: string;
}

function Loading(props: Props) {
  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        paddingTop: 100,
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <CircularProgress color={"primary"} style={{ alignSelf: "center" }} />
      {props.text && (
        <p style={{ color: props.color, fontSize: 16, fontWeight: 500 }}>
          {props.text}
        </p>
      )}
    </div>
  );
}

export default Loading;
